import { createApi } from "@reduxjs/toolkit/query/react";
import baseQueryWithReauth from "./baseQueryWithReauth";

export const mindfulnessApi = createApi({
  reducerPath: "mindfulnessApi",
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    getPlaylistData: builder.query({
      query: () => "api/mh/playlist/",
    }),
    audioRewards: builder.mutation({
      query: (body) => ({
        url: `api/r/event`,
        method: "POST",
        body,
      }),
    }),
  }),
});

export const { useGetPlaylistDataQuery, useAudioRewardsMutation } = mindfulnessApi;
